import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowLeftFromBracketRound = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.334 19a1 1 0 0 1 1-1h3.667V6h-3.667a1 1 0 1 1 0-2h4.667a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4.667a1 1 0 0 1-1-1Zm-2.96-12.374a1 1 0 0 1 0 1.414L7.418 11h7.693a1 1 0 0 1 0 2h-7.7l2.963 2.959a1 1 0 1 1-1.414 1.415l-4.666-4.662a1 1 0 0 1-.001-1.414l4.666-4.672a1 1 0 0 1 1.415 0Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowLeftFromBracketRound);
export default Memo;
